import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import { ButtonTemplate } from '../ButtonTemplate';
import * as styles from './Chip.module.scss';
export const Chip = ({ active, iconStart: IconStart, iconEnd: IconEnd, label, disabled, className, as, ...rest }) => (_jsxs(ButtonTemplate, { ...rest, as: as, disabled: disabled, className: cn(styles.chip, 'u-p-xxs u-border', className, {
        [styles.active]: active && !disabled,
        [styles.disabled]: disabled,
    }), children: [IconStart && (_jsx(IconStart, { "aria-hidden": true, className: "u-icon-m u-m-l-xs u-m-r-xxs" })), _jsx("span", { className: styles.overlay }), _jsx("span", { className: cn('u-typography-h7 u-typography-no-wrap', {
                'u-p-l-xs': !IconStart,
                'u-p-r-xs': !IconEnd,
            }), children: label }), IconEnd && (_jsx(IconEnd, { "aria-hidden": true, className: "u-icon-m u-color-inherit u-m-l-xxs u-m-r-xs" }))] }));
//# sourceMappingURL=Chip.js.map